var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5391 22H7.53906C7.12906 22 6.78906 21.66 6.78906 21.25C6.78906 20.84 7.12906 20.5 7.53906 20.5H17.5391C17.9491 20.5 18.2891 20.84 18.2891 21.25C18.2891 21.66 17.9491 22 17.5391 22Z",
    fill: "#65CB8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8873 5.52004L16.8873 8.38004C16.3573 8.76004 15.5973 8.53004 15.3673 7.92004L13.4773 2.88004C13.1573 2.01004 11.9273 2.01004 11.6073 2.88004L9.70733 7.91004C9.47733 8.53004 8.72733 8.76004 8.19733 8.37004L4.19733 5.51004C3.39733 4.95004 2.33733 5.74004 2.66733 6.67004L6.82733 18.32C6.96733 18.72 7.34733 18.98 7.76733 18.98H17.2973C17.7173 18.98 18.0973 18.71 18.2373 18.32L22.3973 6.67004C22.7373 5.74004 21.6773 4.95004 20.8873 5.52004ZM15.0373 14.75H10.0373C9.62733 14.75 9.28733 14.41 9.28733 14C9.28733 13.59 9.62733 13.25 10.0373 13.25H15.0373C15.4473 13.25 15.7873 13.59 15.7873 14C15.7873 14.41 15.4473 14.75 15.0373 14.75Z",
    fill: "#65CB8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.6f83f5bfe7c3aafd803f9353f12a682f.svg";
export { ForwardRef as ReactComponent };